import ReactMarkdown, { type Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'

const COMPONENTS: Components = {
  h1: ({ children }) => <h1 className="mt-3 text-base font-bold first:mt-0">{children}</h1>,
  h2: ({ children }) => <h2 className="mt-3 text-sm font-bold uppercase tracking-wide text-gold-600 first:mt-0">{children}</h2>,
  h3: ({ children }) => <h3 className="mt-2 text-sm font-semibold first:mt-0">{children}</h3>,
  p: ({ children }) => <p className="text-sm leading-relaxed">{children}</p>,
  ul: ({ children }) => <ul className="list-disc space-y-0.5 pl-5 text-sm">{children}</ul>,
  ol: ({ children }) => <ol className="list-decimal space-y-0.5 pl-5 text-sm">{children}</ol>,
  li: ({ children }) => <li className="leading-relaxed">{children}</li>,
  strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
  em: ({ children }) => <em className="italic">{children}</em>,
  a: ({ href, children }) => <a href={href} target="_blank" rel="noreferrer" className="text-gold-600 underline">{children}</a>,
  code: ({ children }) => <code className="rounded bg-muted px-1 py-0.5 text-xs">{children}</code>,
  blockquote: ({ children }) => <blockquote className="border-l-2 border-gold-300 pl-3 italic text-muted-foreground">{children}</blockquote>,
  hr: () => <hr className="my-3 border-border" />,
}

/** Rendered Markdown (GFM) styled for the Mantastic theme. */
export function Markdown({ children }: { children: string }) {
  return (
    <div className="space-y-1.5">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={COMPONENTS}>{children}</ReactMarkdown>
    </div>
  )
}
